import React from "react";
import MainHeader from "components/AppHeader/mainHeader";
const AppHeader:React.FC<{}> = ():JSX.Element=>{
    return (
        <div>
            <MainHeader />
        </div>
    )
}
export default AppHeader;